export const comCopy = {
  com_layout_title: "如何配置 TypeScript",
  com_layout_description: "在线上或线下与其他 Typescript 使用者交流",
  com_headline: "联系我们",
  com_connect_online: "在线",
  com_connect_online_description:
    " 让我们知道什么地方做得好，什么地方可以做得更好，并了解最新进展。",
  com_online_stack_overflow_desc:
    "与您的同路人互动，并使用‘　typescript　’标签询问有关 TypeScript 的问题",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "交流",
  com_online_discord_desc:
    "在 TypeScript 社区聊天室中与其他 TypeScript 用户聊天。",
  com_online_github_desc: "找到了 bug，或者有你独到的见解？",
  com_online_github_href: "在 GitHub 上告诉我们",
  com_online_twitter_desc: "跟进最新进展。在 Twitter 上关注我们",
  com_online_blog_desc: "了解最新的 Typescript 的进展，通过我们的",
  com_online_typed_desc: "TypeScript 定义文件",
  com_online_typed_href: "浏览数千个",
  com_online_typed_available_for: "可用的通用库和框架",
  com_person: "亲身参与",
  com_conferences: "会议",
  com_conferences_alt_img: "标识",
  nav_: {
    id: "foo",
    defaultMessage: "foo",
  },
}
